import {Component, OnDestroy, OnInit} from '@angular/core';
import {
  FormControl, ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from "@angular/forms";
import {User} from "../../services/user/user";
import {RatesSroMasterService} from "../../services/rates-sro-master/rates-sro-master.service";
import {AlertService} from "../../services/alert/alert.service";
import {LoadingService} from "../../services/loading/loading.service";
import {StateCountryService} from "../../services/state-country/state-country.service";
import {UserService} from "../../services/user/user.service";
import { CommonModule, NgFor, NgIf} from '@angular/common';
import {BsDatepickerModule} from "ngx-bootstrap/datepicker";
import {CommonValidators} from "../../shared/common-components/common-validators";
import {TimepickerModule} from "ngx-bootstrap/timepicker";
import AppConstants from "../../shared/common-components/AppConstants";
import {Address,  StateCountry} from "../../shared/common-components/common-structure";
import {filter, map, shareReplay, tap} from "rxjs/operators";
import { BehaviorSubject, Observable, takeWhile} from "rxjs";
import {TypeaheadMatch, TypeaheadModule, TypeaheadOptions} from "ngx-bootstrap/typeahead";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {FrtOtoRateQueryAddressesComponent} from "./frt-oto-rate-query-addresses/frt-oto-rate-query-addresses.component";
import {Router} from "@angular/router";
import {
  FrtOtoShipmentPackageInfoModalComponent
} from "./frt-oto-shipment-package-info/frt-oto-shipment-package-info.component";
import {FrtOtoRequest} from "../../services/frt-oto-rate-query/frt-oto-request";
import {FrtOtoRateQueryService} from "../../services/frt-oto-rate-query/frt-oto-rate-query.service";
import {NameAndAddressService} from "../../services/name-and-address/name-and-address.service";

@Component({
    selector: 'app-frt-oto-rate-query',
    imports: [
        ReactiveFormsModule,
        BsDatepickerModule,
        TimepickerModule,
        NgFor, NgIf, CommonModule, TypeaheadModule
        
    ],
    templateUrl: './frt-oto-rate-query.component.html',
    styleUrl: './frt-oto-rate-query.component.css'
})
export class FrtOtoRateQueryComponent implements OnInit, OnDestroy {
  orgId: any;
  showGssrError: Boolean = false;
  private defaultCountry = new BehaviorSubject<StateCountry>(null);
  typeaheadOriginLoading: boolean;
  typeaheadDestinationLoading: boolean;
  dataSourceOrigin: Observable<any>;
  dataSourceDestination: Observable<any>;
  bsModalRef: BsModalRef;
  typeaheadLoading: any;

  allCountriesFrtList$ = this.stateCountryService.getAllCountries().pipe(
    map(stateCountries => stateCountries.filter(country => country.businessType.toLowerCase().indexOf('hhg') > -1 && (country.parentCountryId === 365 || country.parentCountryId === 326)) ),
    tap((allCountries) => {
      const defaultOrigin = allCountries.find(x => {
        return x.stateCountryCode === 'US00';
      });
      this.defaultCountry.next(defaultOrigin);
    }),
    shareReplay(1)
  );
  freightQueryForm: UntypedFormGroup;
  listHrs: {key: String, value:String}[] = [];
  tmssloader: any;
  minDate = new Date();
  maxDate = new Date();
  currentUser: User;
  allAddressExist = false;
  originAddress;
  destinationAddress;
  shipperAddress;
  billToAddress;
  consigneeAddress;
  issuingOffice;
  packagesExist = true;
  validationMessages = {
    'moveDate': [
      {type: 'required', message: 'Pickup Date is required'}
    ],
    'requiredDeliveryDate': [
      {type: 'required', message: 'Delivery Date is required'}
    ]
  };
  observer$ = new BehaviorSubject(true);
  constructor(private ratesSroMasterService: RatesSroMasterService, private router: Router, private frtOtoRateQueryService: FrtOtoRateQueryService,
    private formBuilder: UntypedFormBuilder, private alertService: AlertService, private modalService: BsModalService,
    private loader: LoadingService, private stateCountryService: StateCountryService,
    private userService: UserService, private nameAndAddressService: NameAndAddressService) {
    this.minDate.setFullYear(this.minDate.getFullYear() - 6);
    this.tmssloader = this.loader;
    this.dataSourceOrigin = Observable.create((observer: any) => {
      this.ratesSroMasterService.getLocations(this.freightQueryForm.get('asyncOriginSearchString').value)
        .subscribe((result: any) => {
          observer.next(result);
        });
    });
    this.dataSourceDestination = Observable.create((observer: any) => {
      this.ratesSroMasterService.getLocations(this.freightQueryForm.get('asyncDestinationSearchString').value)
        .subscribe((result: any) => {
          observer.next(result);
        });
    });
  }

  /**
   * @description initializes the form and gets all the accessorials
   */
  ngOnInit() {
    this.initializeForm();
    this.generateHours();
    this.getCurrentUser();
    this.onValueChanges();
    this.defaultCountry
      .pipe(filter(value => value != null))
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(defaultCountry => {
        this.freightQueryForm.get('originCountryId').setValue(defaultCountry, {emitEvent: false, onlySelf: false});
        this.freightQueryForm.get('destinationCountryId').setValue(defaultCountry, {emitEvent: false, onlySelf: false});
      });
  }

  generateHours(){
    this.listHrs = AppConstants.generateHours();
  }

  submit() {
    const formValue = this.freightQueryForm.value;
    const payload = new FrtOtoRequest();
    payload.frtOtoRequestId = 0;
    payload.requestDateTime = new Date().toISOString();
    payload.userId = this.currentUser.id;
    payload.organizationId = this.currentUser.organizationId;
    payload.queryType = 'FRT';
    payload.quoteDateby = new Date(formValue.requestDateTime).toISOString();
    payload.fundingPaAuthority = 0;
    payload.expediteFreightShipment = formValue.expediteFreightShipment === 'yes' ? 1 : 0;
    payload.pickupDate = formValue.moveDate;
    payload.pickupTime = formValue.moveDateTime;
    payload.requiredDeliveryDate = formValue.requiredDeliveryDate;
    payload.deliveryTime = formValue.requiredDeliveryDateTime;
    payload.declaredShipmentValue = formValue.declaredValue;
    payload.pocAtPickup = "";
    payload.pocAtPickupPhone = "";
    payload.pocAtPickupEmail = "";
    payload.pickupLocationname = "";
    payload.pickupRestrictions = formValue.moveDateComments;
    payload.pocAtDestination = "";
    payload.pocAtDestinationPhone = "";
    payload.pocAtDestinationEmail = "";
    payload.destinationLocationName = "";
    payload.destinationRestrictions = formValue.deliveryDateComments;
    payload.estimatedWeight = formValue.estimatedWeight;
    payload.estimatedMiles = formValue.estimatedMiles;
    payload.estimatedCuFt = formValue.estimatedCuFt;
    payload.additionalNotes = formValue.additionalNotes;
    payload.originZipId = formValue.originId.uspsZipId;
    payload.destinationZipId =  formValue.destinationId.uspsZipId;
    payload.originCountryId =  formValue.originCountryId.stateCountryId;
    payload.destinationCountryId =  formValue.destinationCountryId.stateCountryId;
    console.log(payload);
    this.frtOtoRateQueryService.saveOtoRequest(payload).subscribe(res => {
      console.log(res);
    })
  }

  /**
   * @description initializes frt query form.
   */
  initializeForm() {
    this.freightQueryForm = this.formBuilder.group({
      requestDateTime: new FormControl(new Date(), Validators.required),
      expediteFreightShipment: new FormControl(null, Validators.required),
      shipper: new FormControl('', Validators.required),
      customer: new FormControl('', Validators.required),
      shipperEmail: new FormControl('', [Validators.required, CommonValidators.email]),
      shipperPhone: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(15), CommonValidators.numeric]),
      agencyShipmentIdNo: new FormControl(null),
      agencyLocationCode: new FormControl(null),
      declaredValue: new FormControl(null, Validators.required),
      tspProBillNo: new FormControl(null),
      moveDateComments: new FormControl(''),
      deliveryDateComments: new FormControl(''),
      additionalNotes: new FormControl(''),
      moveDate: new FormControl('', Validators.required),
      moveDateTime: new FormControl('', Validators.required),
      requiredDeliveryDate: new FormControl('', Validators.required),
      requiredDeliveryDateTime: new FormControl('', Validators.required),
      originId: new FormControl(null, [Validators.required]),
      destinationId: new FormControl(null, [Validators.required]),
      originCountryId: new FormControl(null, [Validators.required]),
      destinationCountryId: new FormControl(null, [Validators.required]),
      asyncOriginSearchString: new FormControl(null),
      asyncDestinationSearchString: new FormControl(null),
      estimatedWeight: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]{1,8}?$')]),
      estimatedMiles: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]+(.[0-9]{1,2})?$')]),
      estimatedCuFt: new FormControl(null, [Validators.pattern('^[0-9]*$')]),
    });
  }

  pickUpDateChange(pickupdate: any) {
    this.freightQueryForm.get('moveDate').setValue(pickupdate.target.value);
  }
  deliveryDateChange(pickupdate: any) {
    this.freightQueryForm.get('requiredDeliveryDate').setValue(pickupdate.target.value);
  }

  isAddressInvalid() {
    return this.freightQueryForm.invalid;
  }

  enterAddressModal() {
    const initialState: any = {
      origin: this.freightQueryForm.get('originId').value,
      destination: this.freightQueryForm.get('destinationId').value
    };
    this.bsModalRef = this.modalService.show(FrtOtoRateQueryAddressesComponent, { initialState, backdrop: 'static', class: 'modal-xl' });
    this.bsModalRef.content.emitData.subscribe(result => {
      console.log(result);
      const payload: any = [
        {
          "nameAddressId": null,
          "frtOtoRequestId": null,
          "shipmentsId": null,
          "recordType": "Origin",
          "defaultAddress": null,
          "firstName": null,
          "lastName": null,
          "middleInitial": null,
          "addressLine1": result?.origin.addressLine1,
          "addressLine2": result?.origin.addressLine2,
          "city": result?.origin.city,
          "stateId": result?.origin.stateId,
          "zipCode": result?.origin.zipCode,
          "countryId": result?.origin.countryId,
          "phone": result?.origin.phone,
          "phoneExt": result?.origin.phoneExt,
          "emailAddress": result?.origin.emailAddress,
          "alternatePhone": result?.origin.alternatePhone,
          "otherContactInfo": result?.origin.otherContactInfo,
          "issuingOfficerTitle": null,
          "issuingOfficeName": null,
        },
        {
          "nameAddressId": null,
          "frtOtoRequestId": null,
          "recordType": "Shipper",
          "defaultAddress": null,
          "firstName": null,
          "lastName": null,
          "middleInitial": null,
          "addressLine1": result?.shipper.addressLine1,
          "addressLine2": result?.shipper.addressLine2,
          "searchString": result?.shipper.searchString,
          "uspsCity": result?.shipper.uspsCity,
          "city": result?.shipper.city,
          "state": result?.shipper.state,
          "stateId": result?.shipper.stateId,
          "zipCode": result?.shipper.zipCode,
          "countryId": result?.shipper.countryId,
          "phone": result?.shipper.phone,
          "phoneExt": result?.shipper.phoneExt,
          "emailAddress": result?.shipper.emailAddress,
          "alternatePhone": result?.shipper.alternatePhone,
          "otherContactInfo": result?.shipper.otherContactInfo,
          "issuingOfficerTitle": null,
          "issuingOfficeName": null
        },
        {
          "nameAddressId": null,
          "frtOtoRequestId": null,
          "shipmentPrefAddressesId": null,
          "recordType": "Bill To",
          "defaultAddress": null,
          "firstName": null,
          "lastName": null,
          "middleInitial": null,
          "addressLine1": result?.billTo.addressLine1,
          "addressLine2": result?.billTo.addressLine2,
          "searchString": result?.billTo.searchString,
          "uspsCity": result?.billTo.uspsCity,
          "city": result?.billTo.city,
          "state": result?.billTo.state,
          "stateId": result?.billTo.stateId,
          "zipCode": result?.billTo.zipCode,
          "countryId": result?.billTo.countryId,
          "phone": result?.billTo.phone,
          "phoneExt": result?.billTo.phoneExt,
          "emailAddress": result?.billTo.emailAddress,
          "alternatePhone": result?.billTo.alternatePhone,
          "otherContactInfo": result?.billTo.otherContactInfo,
          "issuingOfficerTitle": null,
          "issuingOfficeName": null
        },
        {
          "nameAddressId": null,
          "frtOtoRequestId": null,
          "shipmentPrefAddressesId": null,
          "recordType": "Destination",
          "defaultAddress": null,
          "firstName": null,
          "lastName": null,
          "middleInitial": null,
          "addressLine1": result?.destination.addressLine1,
          "addressLine2": result?.destination.addressLine2,
          "searchString": result?.destination.searchString,
          "uspsCity": result?.destination.uspsCity,
          "city": result?.destination.city,
          "state": result?.destination.state,
          "stateId": result?.destination.stateId,
          "zipCode": result?.destination.zipCode,
          "countryId": result?.destination.countryId,
          "phone": result?.destination.phone,
          "phoneExt": result?.destination.phoneExt,
          "emailAddress": result?.destination.emailAddress,
          "alternatePhone": result?.destination.alternatePhone,
          "otherContactInfo": result?.destination.otherContactInfo,
          "issuingOfficerTitle": null,
          "issuingOfficeName": null
        },
        {
          "nameAddressId": null,
          "frtOtoRequestId": null,
          "shipmentPrefAddressesId": null,
          "recordType": "Consignee",
          "defaultAddress": null,
          "firstName": null,
          "lastName": null,
          "middleInitial": null,
          "addressLine1": result?.consignee.addressLine1,
          "addressLine2": result?.consignee.addressLine2,
          "searchString": result?.consignee.searchString,
          "uspsCity": result?.consignee.uspsCity,
          "city": result?.consignee.city,
          "state": result?.consignee.state,
          "stateId": result?.consignee.stateId,
          "zipCode": result?.consignee.zipCode,
          "countryId": result?.consignee.countryId,
          "phone": result?.consignee.phone,
          "phoneExt": result?.consignee.phoneExt,
          "emailAddress": result?.consignee.emailAddress,
          "alternatePhone": result?.consignee.alternatePhone,
          "otherContactInfo": result?.consignee.otherContactInfo,
          "issuingOfficerTitle": null,
          "issuingOfficeName": null
        },
        {
          "nameAddressId": null,
          "frtOtoRequestId": null,
          "shipmentPrefAddressesId": null,
          "recordType": "Issue Office",
          "defaultAddress": null,
          "firstName": result?.issuingOffice.firstName,
          "lastName": result?.issuingOffice.lastName,
          "middleInitial": result?.issuingOffice.middleInitial,
          "addressLine1": null,
          "addressLine2": null,
          "searchString": null,
          "uspsCity": null,
          "city": null,
          "state": null,
          "stateId": null,
          "zipCode": null,
          "countryId": null,
          "phone": result?.issuingOffice.phone,
          "phoneExt": null,
          "emailAddress": null,
          "alternatePhone": null,
          "otherContactInfo": null,
          "issuingOfficerTitle": result?.issuingOffice.issuingOfficerTitle,
          "issuingOfficeName": result?.issuingOffice.issuingOfficeName
        }
      ];
      this.nameAndAddressService.saveAddresses(payload).subscribe(res => {
        console.log(res);
        this.allAddressExist = true;
        this.originAddress = this.getAddress(result?.origin);
        this.destinationAddress = this.getAddress(result?.destination);
        this.shipperAddress = this.getAddress(result?.shipper);
        this.billToAddress = this.getAddress(result?.billTo);
        this.consigneeAddress = this.getAddress(result?.consignee);
      })
    });
  }
  getAddress(address: Address): string {
    return [address.addressLine1, address.addressLine2, address.city, address.stateId, address.zipCode]
      .filter((value) => !!value).join(', ');
  }

  openPackageModal() {
    const initialState = {
    };
    this.bsModalRef = this.modalService.show(FrtOtoShipmentPackageInfoModalComponent, { initialState, backdrop: 'static', class: 'modal-xl' });
    /*this.router.navigate(['/frtpackageinfo'], {
      queryParams: {
        bookshipmentid: null,
        frtShipmentDetailsId: null,
        organizationId: this.orgId,
        ratesSroInfo: null
      }
    });*/
  }

  pcMilerService(originZipCode, destinationZipCode, pickUpDate) {
    if (originZipCode !== null && destinationZipCode !== null && originZipCode !== undefined && destinationZipCode !== undefined
      && originZipCode !== '' && destinationZipCode !== '') {
      this.loader.show();
      this.ratesSroMasterService.getMiles(originZipCode, destinationZipCode, 'FRT', pickUpDate.toISOString()).subscribe(estimatedMiles => {
        // this.freightQueryForm.get('estimatedMiles').patchValue(new RoundPipe().transform(estimatedMiles), {
        this.freightQueryForm.get('estimatedMiles').patchValue(estimatedMiles);
        this.loader.hide();
      }, error2 => {
        this.loader.hide();
        this.alertService.info('cannot get the mileage between the above origin and destination');
      });
    }

  }

  onValueChanges() {
    this.freightQueryForm.get('originId').valueChanges.subscribe(origin => {
      // this.freightQueryForm.get('estimatedWeight').setValue(null);
      if (origin) {
        if (this.freightQueryForm.get('destinationId').value) {
          const originZipCode = origin.zipCode;
          const destinationZipCode = this.freightQueryForm.get('destinationId').value.zipCode;
          const pickupDate = this.freightQueryForm.get('requestDateTime').value;
          //const pickupdateFormatted = moment(pickupDate).format('MM/dd/yyyy');
          if (AppConstants.isNotNullCondition(this.currentUser)) {
            this.pcMilerService(originZipCode, destinationZipCode, pickupDate);
          }
        }
      }
    });
    this.freightQueryForm.get('destinationId').valueChanges.subscribe(destination => {
      this.freightQueryForm.get('estimatedMiles').setValue(null);
      if (destination) {
        if (this.freightQueryForm.get('originId').value) {
          const originZipCode = this.freightQueryForm.get('originId').value.zipCode;
          const destinationZipCode = destination.zipCode;
          const pickupDate = this.freightQueryForm.get('requestDateTime').value;
          //const pickupdateFormatted = moment(pickupDate).format('MM/dd/yyyy');
          // calling pc miler for non carrier users only
          if (AppConstants.isNotNullCondition(this.currentUser)) {
            this.pcMilerService(originZipCode, destinationZipCode, pickupDate);
          }
        }
      }
    });
  }

  getCurrentUser() {
    this.userService
      .getCurrentUserObservable()
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe((currentUser) => {
        this.currentUser = currentUser;
        if (AppConstants.isNotNullCondition(this.currentUser)) {
          this.freightQueryForm.get('shipper').setValue(this.currentUser.agencyBureauName);
          this.freightQueryForm.get('shipper').disable();
          this.freightQueryForm.get('customer').setValue(this.currentUser.firstName + this.currentUser.lastName);
          this.freightQueryForm.get('customer').disable();
          this.freightQueryForm.get('shipperEmail').setValue(this.currentUser.email);
          this.freightQueryForm.get('shipperEmail').disable();
          this.freightQueryForm.get('shipperPhone').setValue(this.currentUser.phone);
          this.freightQueryForm.get('shipperPhone').disable();
          this.orgId = this.currentUser.organizationId;
        } else {
          this.orgId = -1;
        }
      });
  }

  generateDefaultTime(){
    const x = new Date();
    x.setHours(0,0,0,0);
    return x;
  }

  ngOnDestroy(): void {
    this.observer$.next(false);
  }

  /**
   * @description formats the date into yyyy-mm-dd format
   * @param date: Jan 01, 0000
   */
  formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    return [year, month, day].join('-');
  }

  compareCountryFn(c1: StateCountry, c2: StateCountry) {
    return c1 && c2 ? c1.stateCountryId === c2.stateCountryId : c1 === c2;
  }

  isFormElementInValid(fullFormControlName: string) {
    const fromElement = this.freightQueryForm.get(fullFormControlName);
    return fromElement && fromElement.invalid &&
      fromElement.touched;
  }

  typeaheadOriginOnSelect(e: TypeaheadMatch): void {
    this.freightQueryForm.get('originId').setValue(e.item);
  }

  typeaheadDestinationOnSelect(e: TypeaheadMatch): void {
    this.freightQueryForm.get('destinationId').setValue(e.item);
  }

  changeTypeaheadOriginLoading(e: boolean): void {
    this.typeaheadOriginLoading = e;
  }

  changeTypeaheadDestinationLoading(e: boolean): void {
    this.typeaheadDestinationLoading = e;
  }

  onWeightCubicFtChange() {
    this.showGssrError = false;
    if (this.freightQueryForm.get('estimatedWeight').value && this.freightQueryForm.get('estimatedCuFt').value) {
      const minCubicFt = (this.freightQueryForm.get('estimatedWeight').value / 40);
      this.showGssrError = !(this.freightQueryForm.get('estimatedCuFt').value >=  minCubicFt);
    }
  }
}
